<div class="translation-form">
  <app-dynamic-form
    (onFormLanguageChanged)="onLanguageChanged($event)"
    [formProperties]="formProperties"
    [formGroup]="formGroup"
  >
  </app-dynamic-form>
  <app-loading *ngIf="postTranslationLoading$ | async"></app-loading>
  <div class="toolbar">
    <sui-button
      *ngIf="!hasTranslationLanguage"
      variant="primary"
      [leadingIcon]="['fas', 'plus']"
      (click)="setTranslation()"
    >
      {{ "btn.create" | translate }}
    </sui-button>

    <sui-button
      *ngIf="hasTranslationLanguage"
      variant="primary"
      [leadingIcon]="['fas', 'edit']"
      (click)="setTranslation()"
    >
      {{ "btn.update" | translate }}
    </sui-button>

    <sui-button
      variant="secondary"
      [leadingIcon]="['fas', 'language']"
      (click)="translateContent()"
    >
      {{ "post-translation.button.translate" | translate }}
    </sui-button>

    <sui-button
      variant="secondary"
      [leadingIcon]="['fas', 'copy']"
      (click)="copyFromOriginal()"
    >
      {{ "post-translation.button.copy-from-original" | translate }}
    </sui-button>
  </div>
</div>
